// Path data for inline SVG icons. No font files, no markup strings.
// components.ts draws these with createElementNS.

export const ICON_PATHS = {
  home: "M4 11.2 12 4.5l8 6.7V20a1 1 0 0 1-1 1h-5.2v-5.4H10.2V21H5a1 1 0 0 1-1-1v-8.8Z",
  review: "M7 4.5h10a2 2 0 0 1 2 2V19l-3.2-2.1L12.5 19l-3.3-2.1L6 19V6.5a2 2 0 0 1 2-2Z",
  activity: "M3 12h3.2l2.1-5.2 3.4 10.4 2.2-5.2H21",
  books: "M5 4.5h9.2A2.8 2.8 0 0 1 17 7.3V19.5H7.2A2.2 2.2 0 0 0 5 21.5V4.5Zm0 0h11.5",
  reports: "M6 3.5h8.2L19 8.2V20a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Zm8 1.2V9h4.2",
  accounts: "M4 8.5h16v9.2a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.7V8.5Zm0 0 1.6-3h12.8l1.6 3",
  alert: "M12 3.8 21 19.2H3L12 3.8Zm0 5.4v4.6",
  chevron: "M7 10l5 5 5-5",
  close: "M7 7l10 10M17 7 7 17",
  check: "M5 12.5 9.2 17 19 7",
} as const;

export type IconName = keyof typeof ICON_PATHS;

export function isIconName(value: string): value is IconName {
  return Object.prototype.hasOwnProperty.call(ICON_PATHS, value);
}
